import React from 'react';
import type { HomeProps } from '../../../shells/types';

/**
 * Phase 73 full — Kids C · Helper Pal (Pip) Home surface.
 *
 * Pip greets the user and offers four conversational big buttons.
 * Each button bridges to an existing surface — Pip is reskin, not
 * re-implementation. SurfaceRegistry stays untouched; Pip just owns
 * the landing experience for kids.
 */
export function PipHome({ ctx }: HomeProps): JSX.Element {
  const go = (target: string, reason: string) => {
    ctx.director.bridge(target, reason);
  };

  return (
    <div className="pip-home" data-testid="pip-home">
      <div className="pip-greeting">
        <span className="pip-avatar" aria-hidden>🦊</span>
        <div className="pip-greet-text">
          <span className="pip-greet-name">Hi! I&apos;m Pip.</span>
          <span className="pip-greet-hint">What would you like to do today?</span>
        </div>
      </div>

      <button
        type="button"
        className="pip-button pip-button-sos"
        data-testid="pip-button-sos"
        onClick={() => go('env-intake', 'pip-sos')}
      >
        <span className="pip-button-glyph" aria-hidden>🚨</span>
        <div className="pip-button-body">
          <span className="pip-button-title">I need help right now</span>
          <span className="pip-button-sub">It&apos;s okay. Pip is here. Tap me when you need it.</span>
        </div>
      </button>

      <button
        type="button"
        className="pip-button"
        data-testid="pip-button-help-others"
        onClick={() => go('env-board', 'pip-help-others')}
      >
        <span className="pip-button-glyph" aria-hidden>🤝</span>
        <div className="pip-button-body">
          <span className="pip-button-title">Help my neighbors</span>
          <span className="pip-button-sub">Pip will show you what&apos;s needed nearby.</span>
        </div>
      </button>

      <button
        type="button"
        className="pip-button"
        data-testid="pip-button-call"
        onClick={() => go('env-voice', 'pip-call')}
      >
        <span className="pip-button-glyph" aria-hidden>📞</span>
        <div className="pip-button-body">
          <span className="pip-button-title">Call someone</span>
          <span className="pip-button-sub">Voice or video to a grown-up you trust.</span>
        </div>
      </button>

      <button
        type="button"
        className="pip-button"
        data-testid="pip-button-message"
        onClick={() => go('sass-chats', 'pip-message')}
      >
        <span className="pip-button-glyph" aria-hidden>💬</span>
        <div className="pip-button-body">
          <span className="pip-button-title">Send a message</span>
          <span className="pip-button-sub">A short note to a friend or family member.</span>
        </div>
      </button>
    </div>
  );
}
